import React from 'react';
import Icon from '../../common/components/Icon';

export interface SectionHeaderProps {
  title: string;
  linkLabel?: string;
  url?: string;
  hasPreIcon?: boolean;
  isExternal?: boolean;
  iconUrl?: string;
  iconComponent?: React.ReactNode;
  hasTitleLink?: boolean;
  hideHeader?: boolean;
  blockId?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  linkLabel,
  url,
  hasPreIcon,
  isExternal,
  iconUrl,
  iconComponent,
  hasTitleLink,
  hideHeader,
  blockId,
}) => {
  if (hideHeader) {
    return null;
  }

  return (
    <div className="category-header" id={blockId}>
      <div className="category-header__title-wrapper">
        {hasPreIcon && iconUrl && (
          <div className="category-header__icon-wrapper">
            <span
              className="category-header__icon"
              style={{
                maskImage: `url(${iconUrl})`,
                WebkitMaskImage: `url(${iconUrl})`,
              }}
            />
          </div>
        )}
        {hasPreIcon && iconComponent && <div className="category-header__icon-wrapper">{iconComponent}</div>}

        {hasTitleLink === true && url ? (
          <a href={url} className="category-header__title-link">
            <h4>{title}</h4>
          </a>
        ) : (
          <h4>{title}</h4>
        )}
      </div>

      {url && linkLabel && (
        <a
          href={url}
          target={isExternal ? '_blank' : undefined}
          rel={isExternal ? 'noopener noreferrer' : undefined}
          className="link link-underline-14"
          aria-label={linkLabel}
        >
          <span className="link__text">{linkLabel}</span>
          {isExternal ? <Icon name="external-link" size="small" /> : <Icon name="link-arrow-right" size="small" />}
        </a>
      )}
    </div>
  );
};

export default SectionHeader;
